import { ReactElement } from "react";
import { AnnouncementCard } from "client/Features/Workspace/Tiles/Hub/Card/AnnouncementCard";
import {
	AnnouncementPreviewItemModel
} from "client/Api/Hub/Announcements/announcementViewer";
import styles from "./HubCardItem.module.less";
import { TimeZone } from "client/DateAndTime/timezones";

export type HubCardItemProps = {
	item: AnnouncementPreviewItemModel;
	onNavigate(): void;
	timezone: TimeZone;
};

export const HubCardItem = (props: HubCardItemProps): ReactElement => {
	const {
		item,
		onNavigate,
		timezone
	} = props;

	return (
		<div className={styles.root}>
			<AnnouncementCard
				item={item}
				onOpen={onNavigate}
				timezone={timezone}
			/>
		</div>
	);
};
HubCardItem.displayName = "HubCardItem";